export const USER_CREATED_TEAM_VIEW = 'user created - team view';